import { jsxs as l, jsx as i } from "react/jsx-runtime";
const h = () => /* @__PURE__ */ l("svg", { width: "20", height: "21", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ i("g", { clipPath: "url(#clip0_249_1037)", children: /* @__PURE__ */ i(
    "path",
    {
      d: "M8.33333 6.71601V13.3827L12.5 10.0493L8.33333 6.71601ZM15.8333 2.54935H4.16667C3.25 2.54935 2.5 3.29935 2.5 4.21601V15.8827C2.5 16.7993 3.25 17.5493 4.16667 17.5493H15.8333C16.75 17.5493 17.5 16.7993 17.5 15.8827V4.21601C17.5 3.29935 16.75 2.54935 15.8333 2.54935ZM15.8333 15.8827H4.16667V4.21601H15.8333V15.8827Z",
      fill: "white"
    }
  ) }),
  /* @__PURE__ */ i("defs", { children: /* @__PURE__ */ i("clipPath", { id: "clip0_249_1037", children: /* @__PURE__ */ i("rect", { width: "20", height: "20", fill: "white", transform: "translate(0 0.0493469)" }) }) })
] });
export {
  h as default
};
//# sourceMappingURL=SlideShowIcon.js.map
